import { render, staticRenderFns } from "./AgentDetailsProxy.vue?vue&type=template&id=201e0ea6&"
import script from "./AgentDetailsProxy.vue?vue&type=script&lang=ts&"
export * from "./AgentDetailsProxy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports